const features = [
  {
    icon: "ri-route-line",
    title: "路線完全自由",
    desc: "從香港出發，自選目的地、途經城市、停留天數。川藏、新疆、海南還是歐洲，一切由您決定。",
    highlight: false,
  },
  {
    icon: "ri-time-line",
    title: "節奏隨心所欲",
    desc: "想走得快還是慢，想多玩幾天還是速戰速決，我們完全配合您的時間表，絕不強行趕路。",
    highlight: false,
  },
  {
    icon: "ri-hotel-line",
    title: "住宿自己揀",
    desc: "高端酒店、精品民宿、特色帳篷，依據您的預算和喜好安排每晚住宿，不將就、不浪費。",
    highlight: false,
  },
  {
    icon: "ri-group-line",
    title: "私家團不夾雜",
    desc: "完全私人出行，只有您的朋友或家人。無需配合陌生人，全程您說了算，私密度最高。",
    highlight: true,
  },
  {
    icon: "ri-car-line",
    title: "車型任選",
    desc: "SUV、MPV、轎車，按人數和路況選配最合適的車型。我們也可協助安排多車同行的車隊出發。",
    highlight: false,
  },
  {
    icon: "ri-camera-line",
    title: "攝影主題可加配",
    desc: "如有特殊興趣（攝影、星空、高原徒步、美食），可加配相關專業嚮導或特色體驗活動。",
    highlight: false,
  },
];

const CustomFeatures = () => (
  <section className="py-24 bg-stone-50">
    <div className="w-full px-6 lg:px-12">
      {/* Header */}
      <div className="text-center mb-16">
        <span className="text-orange-500 text-sm font-semibold tracking-wider uppercase mb-4 block">
          為什麼選擇自訂行程
        </span>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          每一個細節，都由您主導
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          與固定團不同，自訂行程讓您享有完全的主導權。我們處理所有繁瑣手續，您只需告訴我們您的夢想旅程
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((f) => (
          <div
            key={f.title}
            className={`rounded-2xl p-7 border transition-all group hover:-translate-y-1 ${
              f.highlight
                ? "bg-orange-500 border-orange-500 text-white"
                : "bg-white border-stone-100 hover:border-orange-200"
            }`}
          >
            <div
              className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${
                f.highlight ? "bg-white/20" : "bg-orange-50 group-hover:bg-orange-100"
              } transition-colors`}
            >
              <i
                className={`${f.icon} text-xl ${
                  f.highlight ? "text-white" : "text-orange-500"
                }`}
              ></i>
            </div>
            <h3
              className={`text-lg font-bold mb-3 ${
                f.highlight ? "text-white" : "text-gray-900"
              }`}
            >
              {f.title}
            </h3>
            <p
              className={`text-sm leading-relaxed ${
                f.highlight ? "text-white/85" : "text-gray-500"
              }`}
            >
              {f.desc}
            </p>
            {f.highlight && (
              <div className="mt-5 inline-flex items-center gap-1.5 bg-white/20 rounded-full px-3 py-1.5">
                <i className="ri-star-fill text-yellow-300 text-xs"></i>
                <span className="text-white text-xs font-medium">最多客人選擇</span>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Compare Banner */}
      <div className="mt-12 bg-white rounded-2xl border border-stone-100 overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="p-8 border-b md:border-b-0 md:border-r border-stone-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 bg-stone-100 rounded-full flex items-center justify-center">
                <i className="ri-group-2-line text-stone-500"></i>
              </div>
              <h3 className="font-bold text-gray-900">固定團</h3>
            </div>
            <ul className="space-y-3">
              {[
                "路線固定，無法更改",
                "需配合其他客人時間表",
                "節奏由導遊決定",
                "住宿統一安排，無選擇",
                "夾雜陌生人，私密度低",
              ].map((t) => (
                <li key={t} className="flex items-center gap-2 text-gray-500 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-line text-red-400"></i>
                  </div>
                  {t}
                </li>
              ))}
            </ul>
          </div>
          <div className="p-8 bg-orange-50/50">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                <i className="ri-vip-crown-line text-orange-500"></i>
              </div>
              <h3 className="font-bold text-gray-900">自訂行程</h3>
              <span className="text-xs bg-orange-500 text-white px-2.5 py-0.5 rounded-full font-semibold">推薦</span>
            </div>
            <ul className="space-y-3">
              {[
                "路線完全自由，隨時調整",
                "完全私人，只有您的團隊",
                "節奏隨心，想快想慢都可以",
                "住宿自選，按預算配對",
                "全程私密，尊貴體驗",
              ].map((t) => (
                <li key={t} className="flex items-center gap-2 text-gray-700 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-green-500"></i>
                  </div>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CustomFeatures;
